module.exports = __webpack_public_path__ + "img/uthum_mohotha.61753075.jpg";